// extracted by mini-css-extract-plugin
export default {"mainContainer":"Main_mainContainer__2dw6r"};